import React from 'react';
import { useLocation } from 'react-router-dom';
import AskIcon from 'shared/components/ui/AskIcon';
import { openAsk } from 'shared/askDraft';

/**
 * The drafted message: what is open, by id, so Lucid can fetch it. It ends in a
 * space and is left in the composer unsent — the person adds what they want to
 * know ("why was the second tool call slow?") or just presses Enter.
 */
export function askLucidPrompt({ runId, spanId, conversationId }) {
  if (spanId) return `Analyze this span (span_id: ${spanId}${runId ? `, run_id: ${runId}` : ''}). `;
  if (runId) return `Analyze this run (run_id: ${runId}). `;
  if (conversationId) return `Analyze this conversation (conversation_id: ${conversationId}). `;
  return 'Analyze this. ';
}

/**
 * "Ask Lucid" beside a detail drawer's search box: opens Lucid in the side
 * panel, the drawer staying where it is, with the run / span / conversation
 * drafted in. Hidden on /chat, where Lucid is the page itself.
 *
 * A drawer about something else (an end user) passes its own `prompt` and
 * `title`; the same rule applies: end the draft in a space, leave it unsent.
 */
export default function AskLucidButton({ runId, spanId, conversationId, prompt, title }) {
  const location = useLocation();
  if (/\/chat\/?$/.test(location.pathname)) return null;
  const what = spanId ? 'span' : runId ? 'run' : 'conversation';
  return (
    <button
      type="button"
      onClick={() => openAsk(prompt || askLucidPrompt({ runId, spanId, conversationId }))}
      title={title || `Ask Lucid about this ${what}`}
      className="inline-flex h-8 flex-none items-center gap-1.5 rounded-lg border border-[color:var(--border-default)] bg-surface px-2.5 text-[12px] font-medium text-[color:var(--text-primary)] transition-colors hover:bg-surface-hover"
    >
      <AskIcon size={14} className="text-[color:var(--brand-primary)]" />
      Ask Lucid
    </button>
  );
}
